import { productBussiness } from "api/bussiness/product/product-bussiness";
import { GetProducts } from "api/models/request/product/product";
import {
  createProductOptionLabel,
  createProductRenderOption,
} from "commons/ultilities/option-item/label-ultil";
import type { AutoCompleteProvider } from "./factory";

const normalizeProductCustomerId = (
  customerId?: string | number | null,
): string | undefined => {
  if (customerId == null) {
    return undefined;
  }

  const normalizedValue = String(customerId).trim();
  return normalizedValue === "" ? undefined : normalizedValue;
};

export const productAutoCompleteProvider: AutoCompleteProvider = {
  searchOptionItemsAsync: async (keyword, context) => {
    return productBussiness.searchProductAsOptionItems(
      keyword,
      normalizeProductCustomerId(context?.customerId),
    );
  },
  searchOptionItemsPagedAsync: async (keyword, request, context) => {
    const products = await productBussiness.getLists<GetProducts>({
      filter: keyword,
      maxResultCount: request.pageSize,
      skipCount: request.pageIndex * request.pageSize,
      sorting: "",
      customerId: normalizeProductCustomerId(context?.customerId),
      isDisabled: false,
    });

    return {
      items:
        products.items?.map((item) => ({
          value: item.id || "",
          label: createProductOptionLabel(item),
          renderOption: createProductRenderOption(item),
        })) || [],
      totalCount: products.totalCount,
    };
  },
  resolveSelectedOptionAsync: async (value) => {
    const normalizedId = String(value ?? "").trim();
    if (!normalizedId) {
      return null;
    }

    try {
      const product = await productBussiness.getById(normalizedId);
      if (!product?.id) {
        return null;
      }

      return {
        value: product.id,
        label: createProductOptionLabel(product),
        renderOption: createProductRenderOption(product),
      };
    } catch {
      return null;
    }
  },
};
